import Repository from "./Repository";

const resource = "/Perimetre";

export default {
  get({
    searchQuery = "",
    perimetreTypeId,
    applicationId,
    cancelToken = null
  }) {
    return Repository.post(
      `${resource}/Search`,
      {
        pageNumber: 1,
        pageSize: 50
      },
      {
        params: { criteria: searchQuery, perimetreTypeId, applicationId },
        cancelToken
      }
    );
  }
};
